
import { Link, useNavigate } from "react-router-dom"
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  CreditCard,
  DeleteIcon,
  Download,
  DownloadCloud,
  DownloadIcon,
  EllipsisVertical,
  File,
  Home,
  LineChart,
  ListFilter,
  MoreVertical,
  Package,
  Package2,
  PanelLeft,
  Search,
  Settings,
  ShoppingCart,
  Truck,
  Upload,
  Users2,
} from "lucide-react"

import { Badge } from "../../component/ui/badge"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb"
import { Button } from "../../component/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Input } from "../../component/ui/input"
import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from "../../component/ui/Pagination"
import { Progress } from "../../component/ui/progress"
import { Separator } from "../../component/ui/separator"
import { Sheet, SheetContent, SheetTrigger } from "../../component/ui/sheet"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table"
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../component/ui/tooltip"
import Overview from "../../component/investor/Overview"
import FundManagers from "../../component/investor/FundManagers"
import Performance from "../../component/investor/Performance"
import Portfolio from "../../component/investor/Portfolio"
import SchemeDocuments from "../../component/investor/SchemeDocuments"
import { DataTable } from "../../component/table/dataTable"
import { Dashboard } from "../../pages/investorPage/Dashboard"
import NewSchemaForm from "./NewSchemaForm"
import { IoAddOutline, IoDownload, IoDownloadOutline } from "react-icons/io5"
import { IoIosArrowBack, IoIosArrowDown, IoMdDownload } from "react-icons/io"
import { Label } from "../ui/label"
import BasicDatePicker, { DatePicker } from "../ui/date-picker"
import { Dialog, DialogContent, DialogDescription, DialogOverlay, DialogTitle } from "@radix-ui/react-dialog"
import { useEffect, useRef, useState } from "react"
import { getAllSchemeReportsAgainstSchemeName, getEmailTemplatesDropdown, getReportURL, uploadSchemeReport } from "../../utils/util"
import { useDispatch, useSelector } from "react-redux"
import AdvancedDropdown from "../ui/multi-selection-dropdown-menu-with-search"
import { FaRegEye } from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import { loaderSet } from "../../context/actions/loaderAction"
import { alertDanger, alertSuccess } from "../../context/actions/toastAction"
import { nullSchemeInfo } from "../../context/actions/schemeInfoAction"
import Loader from "../loader"
import { reportOptions } from "../../utils/constant"

export const description =
  "An orders dashboard with a sidebar navigation. The sidebar has icon navigation. The content area has a breadcrumb and search in the header. The main area has a list of recent orders with a filter and export button. The main area also has a detailed view of a single order with order details, shipping information, billing information, customer information, and payment information."

export function SchemeView({ back, forWhichUserType }) {

  const [isNewReportUpload, setIsNewReportUpload] = useState(false)
  const [selectedFrequencyTab, setSelectedFrequencyTab] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const handleSchemeReportView = async (report) => {
    try {
      // Check if the report URL is valid before opening
      if (report.report_url) {
        const payload = {
          storedSignedUrl: report?.report_url,
          storedExpirationTime: report?.expired_at,
          fileName: report?.file_name,
          report_id: report?.report_id
        }

        const reportURL = await getReportURL(payload)

        console.log("URL", reportURL)

        // Open the report URL in a new tab
        // window.open(reportUrl, "_blank");
      } else {
        console.log("Invalid report URL");
      }
    } catch (error) {
      console.log("Error in handleSchemeReportView function", error);
    }
  };


  const handleDownloadSchemeReport = async (reportUrl) => {
    try {
      // Check if the report URL is valid
      if (reportUrl) {
        // Create an anchor element
        const link = document.createElement("a");
        link.href = reportUrl;
        link.download = "scheme_report.pdf"; // Set the download filename

        // Append the link to the document, click it to trigger the download, and remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("Invalid report URL");
      }
    } catch (error) {
      console.log("Error in handleDownloadSchemeReport function", error);
    }
  };



  const buttonOptions = [


    {
      icon: <FaRegEye />,
      alt: "",
      text: <span className="text-base font-semibold">View</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: "black",
      name: "View",
      actionHandleSchemeReportView: handleSchemeReportView
    },
    // {
    //   icon: <IoMdDownload />,
    //   alt: "",
    //   text: <span className="text-base font-semibold">Download</span>,
    //   iconHeight: 17,
    //   iconWidth: 17,
    //   iconColor: "black",
    //   name: "Download",
    //   actionHandleDownloadSchemeReport: handleDownloadSchemeReport
    // },
  ];

  const columns = [
    { id: 'report_name', header: 'Report Name' },
    // { id: 'report_type', header: 'Report Type' },
    { id: 'created_at', header: 'Uploaded Date' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];

  const schemeInfo = useSelector(state => state.schemeInfo)
  const fileInputRef = useRef()
  const [selectedFiles, setSelectedFiles] = useState([])
  const [isOpenUploadDocumentConfirmation, setIsOpenUploadDocumentConfirmation] = useState(false)

  const handleIsOpenUploadDocumentConfirmation = () => {
    setIsOpenUploadDocumentConfirmation(true)
  }
  const handleIsCloseUploadDocumentConfirmation = () => {
    setIsOpenUploadDocumentConfirmation(false)
  }
  // Trigger the file input click when the button is clicked
  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the hidden file input's click
    }

  };

  // Handle file selection change
  const handleFileChange = (event) => {
    const files = event.target.files;
    setSelectedFiles(files);
    console.log("Files selected:", files);
    if (files.length > 0) {
      setIsOpenUploadDocumentConfirmation(true)

    }
  };




  const handleSchemeReport = async () => {
    setIsLoading(true)
    setIsNewReportUpload(false)
    handleIsCloseUploadDocumentConfirmation(false)
    console.log("scheme info", schemeInfo);
    const payload = new FormData();

    // Append scheme details

    payload.append('scheme_name', schemeInfo.scheme_name);
    payload.append('scheme_class', schemeInfo.scheme_class);
    payload.append('scheme_id', schemeInfo.scheme_id);
    payload.append('report_type', selectedFrequentsOptions && selectedFrequentsOptions.length > 0 && selectedFrequentsOptions[0] === "Quarterly" ? "quaterly" : selectedFrequentsOptions[0].toLowerCase());
    // const emailTemplates = JSON.stringify([selectedFiles[0], {'A':"A!"}, {'A':"A!"}]);
    payload.append('template_name', selectedEmailTemplateOptions);

    // Debug: Check if selectedFiles is correctly populated
    if (!selectedFiles || selectedFiles.length === 0) {
      console.log("No files selected.");
      return;
    }

    // Create an array of files to append
    const filesArray = Array.from(selectedFiles);
    console.log("selected files", filesArray)

    filesArray.forEach((file) => {
      payload.append('files', file);  // 'files[]' indicates that it's an array
    });
    console.log("payload", [...payload]); // Check if the payload has the files array

    try {
      const response = await uploadSchemeReport(payload);
      console.log("Response for upload scheme report", response);

      // ✅ Handle middleware-level errors (executable file, MIME mismatch, etc.)
      if (response?.errors && response.errors.length > 0) {
        dispatch(alertDanger(response.errors[0])) // shows exact error e.g. "Executable content detected"
        setIsLoading(false)
        return
      }

      if (response?.code === 200) {
        setSelectedFrequencyTab(selectedFrequentsOptions?.[0])
        setIsNewReportUpload(true)
        dispatch(alertSuccess("Successfully uploaded the scheme report"))
        setIsLoading(false)
      } else if (response?.code === 404) {
        dispatch(alertDanger("Investor not found"))
        setIsLoading(false)
      } else if (response?.code === 400) {
        dispatch(alertDanger(response?.message || "Invalid file or missing fields. Please try again."))
        setIsLoading(false)
      } else if (response?.code === 500) {
        dispatch(alertDanger("Server error. Please try again."))
        setIsLoading(false)
      } else {
        // ✅ Catch-all for any other unexpected response
        dispatch(alertDanger("Something went wrong. Please try again."))
        setIsLoading(false)
      }

    } catch (error) {
      dispatch(alertDanger("Upload failed. Please try again."))
      console.log("Error in handle Scheme Report", error);
      setIsLoading(false)
    }
  };

  const [emailTemplateOption, setEmailTemplateOption] = useState([])
  const [selectedEmailTemplateOptions, setSelectedEmailTemplateOptions] = useState([])
  const [selectedFrequentsOptions, setSelectedFrequentsOptions] = useState([])
  useEffect(() => {
    const fetchEmailTemplatesForDropdown = async () => {
      try {
        const response = await getEmailTemplatesDropdown();
        if (response) {
          setEmailTemplateOption(response?.data.filter(emailTemplate => emailTemplate.template_name !== null).map((emailTemplate, index) => (emailTemplate.template_name)));
        }

      } catch (error) {
        console.log("Error in get email template API", error);
      }
    };

    fetchEmailTemplatesForDropdown(); // Call the async function inside useEffect
  }, []); // The empty dependency array ensures this runs only once on component mount





  const tabsList = [
    { label: "Information", value: "information", component: <NewSchemaForm back={back} />, },
    { label: "Reports", value: "reports", component: <DataTable isNewReportUpload={isNewReportUpload} selectedFrequency={selectedFrequencyTab || null} buttonOptions={buttonOptions} back={back} columns={columns} schemeInfo={schemeInfo} tableFor={"SchemeReport"} /> },

  ]

  return (
    <div className="flex min-h-screen w-full flex-col  ">
      {
        isLoading && <Loader />
      }
      <div className="flex flex-col sm:gap-4  sm:pl-1">

        <main className="grid flex-1 items-start gap-4  ">
          <Button
            variant="outline"
            size="sm"
            className=" h-10  gap-1 text-sm w-max self-start "
            onClick={() => {
              if (forWhichUserType === "employee") {
                navigate("/employee")
              }
              if (forWhichUserType === "admin") {
                navigate("/admin")
              }
              dispatch(nullSchemeInfo())
              back()
            }
            }
          >
            <IoIosArrowBack />
            Back
          </Button>
          <div className="grid auto-rows-max items-start gap-4 md:gap-8  lg:col-span-2">

            <Tabs defaultValue="information"  >
              <div className="flex bg-white items-center flex-col ">
                <div className=" flex  w-full flex-col items-start  mt-2" >
                  <TabsList className="  bg-white border-b-2 w-full rounded-md flex justify-start " >
                    {
                      tabsList.map((curElem, index) => (
                        <TabsTrigger key={index} value={curElem.value} tabIndex={index + 1} className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >{curElem.label}</TabsTrigger>
                      ))
                    }

                    {/* <TabsTrigger value="month" className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >Month</TabsTrigger>
                  <TabsTrigger value="year" className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >Year</TabsTrigger> */}
                  </TabsList>
                  <div className="w-full flex justify-between items-start p-2 rounded-md">
                    <div className="flex w-full justify-end items-center gap-4">


                      {/* Dropdown Menu */}

                    </div>
                  </div>

                </div>


              </div>
              {
                tabsList.map((curElem, index) =>
                (
                  <TabsContent key={index} value={curElem.value}>
                    <Card x-chunk="dashboard-05-chunk-3  ">

                      <CardContent className="bg-muted/40 pt-5" >
                        {curElem.value === "reports" &&
                          (<div className=" w-full  flex justify-center items-center text-center mb-4  " >

                            <div className="w-full flex justify-between items-start p-2 bg-[#FFFFFF] rounded-lg">
                              <div className="flex w-full justify-end items-center gap-4">

                                <div className=" h-10 w-64 ">

                                  <AdvancedDropdown
                                    name="Email Template"
                                    id="emailTemplate"
                                    options={emailTemplateOption}
                                    selectedOptions={selectedEmailTemplateOptions}
                                    setSelectedOptions={setSelectedEmailTemplateOptions}
                                    placeholder="Email Template"
                                    select={"single"}
                                    label={false}
                                  //    disabled={selectedSchemeOptions.length===0 && true}
                                  />
                                </div>
                                <div className=" h-10 w-64 ">

                                  <AdvancedDropdown
                                    name="Frequency"
                                    id="frequents"
                                    options={reportOptions}
                                    selectedOptions={selectedFrequentsOptions}
                                    setSelectedOptions={setSelectedFrequentsOptions}
                                    placeholder="Frequency"
                                    select={"single"}
                                    label={false}
                                  //    disabled={selectedSchemeOptions.length===0 && true}
                                  />
                                </div>

                                {/* Search Bar */}

                                {/* <div className="h-10" > 

         <DatePicker/>
              </div> */}
                                {/* Dropdown Menu */}
                                <div className="flex items-center gap-2">
                                  <div className="flex w-64 gap-2  border-[#0D215C] items-center">

                                    <Button
                                      type="button"
                                      disabled={selectedEmailTemplateOptions.length === 0 || selectedFrequentsOptions.length === 0}
                                      onClick={() => (
                                        handleButtonClick()
                                      )}
                                      className="rounded-lg w-full border-none h-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] text-sm flex items-center gap-10">
                                      <Upload size={20} />
                                      Upload</Button>
                                    {/* Hidden File Input */}
                                    <input
                                      type="file"
                                      multiple
                                      accept=".xls,.xlsx,.docx,.pdf"
                                      onChange={handleFileChange}
                                      style={{ display: "none" }}
                                      ref={fileInputRef} // Reference the input element
                                    />
                                  </div>

                                </div>
                              </div>
                            </div>

                          </div>)
                        }

                        {curElem.component}


                      </CardContent>
                    </Card>
                  </TabsContent>
                )
                )
              }
            </Tabs>
          </div>
          <div>

          </div>
        </main>
        {/* Dialog for Upload Document Confirmation */}
        <Dialog open={isOpenUploadDocumentConfirmation} onOpenChange={handleIsCloseUploadDocumentConfirmation}>
          {/* Overlay */}
          <DialogOverlay className="fixed inset-0 bg-black bg-opacity-50 z-40" />

          {/* Dialog Content */}
          <DialogContent className="fixed inset-0 m-auto bg-white z-50 p-6 rounded-lg h-64 overflow-y-auto shadow-lg max-w-lg w-full flex flex-col justify-between">
            <div>
              <DialogTitle className="text-lg font-bold">Upload Document Confirmation</DialogTitle>
              <DialogDescription className="mt-2">
                Do you want to upload the document now?
              </DialogDescription>
              {/* Additional confirmation text */}
              <p className="mt-2 text-gray-500">
                The following document(s) will be uploaded:
              </p>
              {/* Display the selected files in bold and colored text */}
              {selectedFiles && selectedFiles.length > 0 && (
                <ul className="mt-2 list-disc list-inside">
                  {Array.from(selectedFiles).map((file, index) => (
                    <li key={index} className="text-gray-700">
                      <span className="font-semibold text-blue-600">{file.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="mt-4 flex justify-end gap-4">
              <Button type="button" className="bg-red-700 text-white  " onClick={handleIsCloseUploadDocumentConfirmation} >
                Close
              </Button>
              <Button type="button" onClick={() => handleSchemeReport()} className="bg-[#0D215C] text-white  ">Confirm Upload</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

    </div>
  )
}
